module.exports = __webpack_public_path__ + "img/equation.ed0cf08d.svg";